import { createReducer } from '@reduxjs/toolkit'
import * as actions from '../../actions/AppInit/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type AppInitStatus = 'idle' | 'initializing' | 'ready' | 'error'

export type AppInitStore = {
  status: AppInitStatus
  error: string | null
}

const INITIAL_STATE: AppInitStore = {
  status: 'idle',
  error: null
}

const AppInitReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.initStarted, (state) => {
      state.status = 'initializing'
      state.error = null
    })
    .addCase(actions.initReady, (state) => {
      state.status = 'ready'
      state.error = null
    })
    .addCase(actions.initFailed, (state, action) => {
      state.status = 'error'
      state.error = action.payload.error
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default AppInitReducer
